import React from 'react';
import { getDomainConfig, CONTACT_INFO } from '../config';
import './LegalPage.css';

function TermsPage() {
  const config = getDomainConfig();
  const hostname = window.location.hostname.replace('www.', '');
  const displayEmail = `info@${hostname}`;

  return (
    <div className="legal-page">
      <h1>Terms and Conditions</h1>
      <p className="last-updated">Last Updated: February 2026</p>

      <div className="legal-content">
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using {config.name} ({hostname}), operated by {CONTACT_INFO.businessName}
            (the "Company"), you accept and agree to be bound by these Terms and Conditions. If you do
            not agree to these terms, please do not use our website.
          </p>
        </section>

        <section>
          <h2>2. About Our Service</h2>
          <p>
            {config.name} is a B2B product directory and sourcing platform that connects business buyers
            with industrial suppliers and manufacturers. Our website provides product information,
            specifications, and pricing to help businesses find the products they need. We facilitate
            quote requests and supplier connections on behalf of our users.
          </p>
          <p>
            Products listed on our website are offered by third-party suppliers and manufacturers.
            {CONTACT_INFO.businessName} acts as an intermediary to facilitate the sourcing process.
          </p>
        </section>

        <section>
          <h2>3. Use of Service</h2>
          <p>You agree to use the Service only for lawful purposes and in accordance with these Terms.</p>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service in any way that violates applicable laws or regulations</li>
            <li>Impersonate or attempt to impersonate the Company or another user</li>
            <li>Engage in any conduct that restricts or inhibits anyone's use of the Service</li>
            <li>Use any automated system to access the Service without our permission</li>
            <li>Introduce viruses, malware, or other harmful code to our systems</li>
          </ul>
        </section>

        <section>
          <h2>4. Products and Pricing</h2>
          <p>
            We strive to provide accurate product descriptions and pricing. However, we do not warrant
            that product descriptions, pricing, or other content is accurate, complete, or error-free.
            Prices displayed on our website are provided by our supplier network and are subject to
            change without notice.
          </p>
          <p>
            Final pricing, availability, and terms of sale are determined by the supplying vendor at
            the time of purchase. We recommend confirming pricing and specifications directly with
            the supplier before placing an order.
          </p>
        </section>

        <section>
          <h2>5. Quote Requests and Orders</h2>
          <p>
            When you submit a quote request through our platform, we will connect you with relevant
            suppliers who can fulfill your needs. Submitting a quote request does not obligate you to
            purchase, and receiving a quote does not guarantee product availability.
          </p>
          <p>
            Orders placed through our platform are subject to acceptance by the supplying vendor.
            Payment terms, shipping, and delivery are coordinated between the buyer and the supplier.
          </p>
        </section>

        <section>
          <h2>6. Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are owned by
            {' '}{CONTACT_INFO.businessName} and are protected by international copyright, trademark,
            and other intellectual property laws. Product images and descriptions may be owned by their
            respective manufacturers and suppliers.
          </p>
        </section>

        <section>
          <h2>7. Limitation of Liability</h2>
          <p>
            In no event shall {CONTACT_INFO.businessName}, its directors, employees, or agents be liable
            for any indirect, incidental, special, consequential, or punitive damages arising out of or
            relating to your use of the Service. Our total liability for any claims arising from your
            use of the Service shall not exceed the amount paid by you, if any, for accessing the Service.
          </p>
        </section>

        <section>
          <h2>8. Disclaimer of Warranties</h2>
          <p>
            The Service is provided on an "AS IS" and "AS AVAILABLE" basis without warranties of any kind,
            either express or implied. We do not guarantee that the Service will be uninterrupted, secure,
            or error-free.
          </p>
        </section>

        <section>
          <h2>9. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites or services that are not owned or
            controlled by {CONTACT_INFO.businessName}. We have no control over, and assume no
            responsibility for, the content, privacy policies, or practices of any third-party sites.
          </p>
        </section>

        <section>
          <h2>10. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the State of
            New York, United States, without regard to its conflict of law provisions.
          </p>
        </section>

        <section>
          <h2>11. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify users of any material
            changes by posting the new Terms on this page and updating the "Last Updated" date.
            Continued use of the Service after changes constitutes acceptance of the modified Terms.
          </p>
        </section>

        <section>
          <h2>12. Contact Information</h2>
          <p>
            If you have any questions about these Terms, please contact us:
          </p>
          <p><strong>{CONTACT_INFO.businessName}</strong></p>
          <p>Email: {displayEmail}</p>
          <p>Phone: {CONTACT_INFO.phone}</p>
          <p>Address: {CONTACT_INFO.address}, {CONTACT_INFO.city}, {CONTACT_INFO.state} {CONTACT_INFO.zip}</p>
        </section>
      </div>
    </div>
  );
}

export default TermsPage;
